{
  "CONTACT_PANEL": {
    "CONFIRM": {
      "YES": "OK",
      "CANCEL": "Annulla"
    },
    "NOT_AVAILABLE": "Non disponibile",
    "EMAIL_ADDRESS": "Indirizzo email",
    "PHONE_NUMBER": "Numero di telefono",
    "WHATSAPP_USERNAME": "Nome utente WhatsApp",
    "IDENTIFIER": "Identificatore",
    "COPY_SUCCESSFUL": "Copiato negli appunti con successo",
    "COPY_NAME": "Copia nome",
    "COPY_REFERER": "Copia URL",
    "COMPANY": "Azienda",
    "LOCATION": "Posizione",
    "LTV": "LTV",
    "BROWSER_LANGUAGE": "Lingua del browser",
    "CONVERSATION_LANGUAGE": "Lingua della conversazione",
    "CONVERSATION_TITLE": "Dettagli conversazione",
    "VIEW_PROFILE": "Visualizza profilo",
    "BROWSER": "Browser",
    "OS": "Sistema operativo",
    "INITIATED_FROM": "Iniziato da",
    "INITIATED_AT": "Iniziato alle",
    "IP_ADDRESS": "Indirizzo IP",
    "CREATED_AT_LABEL": "Created",
    "NEW_MESSAGE": "Nuovo messaggio",
    "CONVERSATIONS": {
      "NO_RECORDS_FOUND": "Non ci sono precedenti conversazioni associate a questo contatto.",
      "TITLE": "Conversazioni precedenti"
    },
    "LABELS": {
      "CONTACT": {
        "TITLE": "Etichette di contatto",
        "ERROR": "Impossibile aggiornare le etichette"
      },
      "CONVERSATION": {
        "TITLE": "Etichette di conversazione",
        "ADD_BUTTON": "Aggiungi etichette"
      },
      "LABEL_SELECT": {
        "TITLE": "Aggiungi etichette",
        "PLACEHOLDER": "Cerca etichette",
        "NO_RESULT": "Nessuna etichetta trovata",
        "CREATE_LABEL": "Create new label"
      }
    },
    "MERGE_CONTACT": "Unisci contatto",
    "CONTACT_ACTIONS": "Azioni contatto",
    "MUTE_CONTACT": "Block Contact",
    "MUTE_CONTACT_DISABLED": "Non utilizzabile. L'intero dominio del contatto è bloccato.",
    "UNMUTE_CONTACT": "Unblock Contact",
    "BLOCK_CONTACT_DOMAIN": "Blocca dominio del contatto",
    "UNBLOCK_CONTACT_DOMAIN": "Sblocca dominio del contatto",
    "BLOCK_CONTACT_DOMAIN_DISABLED": "Questo dominio del contatto non può essere bloccato.",
    "BLOCK_CONTACT_DOMAIN_MESSAGE": "Bloccare il dominio bloccherà tutti i contatti esistenti e futuri per quel dominio.",
    "UNBLOCK_CONTACT_DOMAIN_MESSAGE": "Sbloccare il dominio rimuoverà il blocco da tutti i contatti per quel dominio (inclusi quelli bloccati manualmente).",
    "BLOCK_PUBLIC_DOMAIN_TITLE": "Dominio email pubblico",
    "BLOCK_PUBLIC_DOMAIN_MESSAGE": "{domain} è un dominio email pubblico utilizzato da molti mittenti non correlati tra loro, quindi non può essere bloccato nella sua interezza. Vuoi bloccare solo questo indirizzo ({email})?",
    "BLOCK_ONLY_THIS_ADDRESS": "Blocca solo questo indirizzo",
    "MUTED_SUCCESS": "Questo contatto è stato bloccato con successo. Le sue conversazioni verranno risolte a breve in background.",
    "UNMUTED_SUCCESS": "This contact is unblocked successfully.",
    "OPEN_JARABOT": "Apri cronologia risposte AI",
    "TRANSLATE_CONVERSATION": "Traduci conversazione",
    "TRANSLATE_INITIATED": "Traduzione avviata. Potrebbe richiedere un momento per conversazioni più lunghe.",
    "TRANSLATE_SUCCESS": "Traduzione della conversazione completata con successo.",
    "TRANSLATE_ERROR": "Impossibile tradurre la conversazione. Riprova.",
    "MOVE_CONVERSATION": "Sposta conversazione",
    "MOVE_CONVERSATION_MISSING_EMAIL": "L'email del contatto è obbligatoria per spostare la conversazione in una casella email",
    "MERGE_CONVERSATION": "Unisci conversazione",
    "CONTACT_DOMAIN_BLOCKED_SUCCESS": "Questo dominio è stato bloccato con successo. Non riceverai notifiche per nessuna conversazione futura.",
    "CONTACT_DOMAIN_UNBLOCKED_SUCCESS": "Questo dominio è stato sbloccato con successo.",
    "SEND_TRANSCRIPT": "Invia trascrizione",
    "EDIT_LABEL": "Modifica",
    "SIDEBAR_SECTIONS": {
      "CUSTOM_ATTRIBUTES": "Attributi personalizzati",
      "CONTACT_LABELS": "Etichette di contatto",
      "PREVIOUS_CONVERSATIONS": "Conversazioni precedenti",
      "NO_RECORDS_FOUND": "Nessun attributo trovato"
    }
  },
  "EDIT_CONTACT": {
    "BUTTON_LABEL": "Modifica contatto",
    "TITLE": "Modifica contatto",
    "DESC": "Modifica dettagli contatto"
  },
  "DELETE_CONTACT": {
    "BUTTON_LABEL": "Elimina contatto",
    "TITLE": "Elimina contatto",
    "DESC": "Elimina dettagli contatto",
    "CONFIRM": {
      "TITLE": "Conferma eliminazione",
      "MESSAGE": "Sei sicuro di voler eliminare ",
      "YES": "Sì, elimina",
      "NO": "No, conserva"
    },
    "API": {
      "SUCCESS_MESSAGE": "Contatto eliminato con successo",
      "ERROR_MESSAGE": "Impossibile eliminare il contatto. Riprova più tardi."
    }
  },
  "CONTACT_FORM": {
    "FORM": {
      "SUBMIT": "Salva",
      "CANCEL": "Annulla",
      "AVATAR": {
        "LABEL": "Immagine del contatto"
      },
      "NAME": {
        "PLACEHOLDER": "Inserisci il nome completo del contatto",
        "LABEL": "Nome completo"
      },
      "BIO": {
        "PLACEHOLDER": "Inserisci la biografia del contatto",
        "LABEL": "Biografia"
      },
      "EMAIL_ADDRESS": {
        "PLACEHOLDER": "Inserisci l'indirizzo email del contatto",
        "LABEL": "Indirizzo email",
        "DUPLICATE": "Questo indirizzo email è in uso per un altro contatto.",
        "ERROR": "Inserisci un indirizzo email valido."
      },
      "PHONE_NUMBER": {
        "PLACEHOLDER": "Inserisci il numero di telefono del contatto",
        "LABEL": "Numero di telefono",
        "HELP": "Il numero di telefono dovrebbe essere di formato E.164 es.: +3915555555 [+][codice nazione][codice zona][numero di telefono locale]",
        "ERROR": "Il numero di telefono deve essere vuoto o di formato E.164",
        "DIAL_CODE_ERROR": "Please select a dial code from the list",
        "DUPLICATE": "Questo numero di telefono è in uso per un altro contatto."
      },
      "LOCATION": {
        "PLACEHOLDER": "Inserisci la posizione del contatto",
        "LABEL": "Posizione"
      },
      "COMPANY_NAME": {
        "PLACEHOLDER": "Inserisci il nome dell'azienda",
        "LABEL": "Nome azienda"
      },
      "COUNTRY": {
        "PLACEHOLDER": "Enter the country name",
        "LABEL": "Nome del paese",
        "SELECT_PLACEHOLDER": "Select",
        "REMOVE": "Rimuovi",
        "SELECT_COUNTRY": "Select Country"
      },
      "CITY": {
        "PLACEHOLDER": "Enter the city name",
        "LABEL": "City Name"
      },
      "SOCIAL_PROFILES": {
        "FACEBOOK": {
          "PLACEHOLDER": "Inserisci il nome utente di Facebook",
          "LABEL": "Facebook"
        },
        "TWITTER": {
          "PLACEHOLDER": "Inserisci il nome utente Twitter",
          "LABEL": "Twitter"
        },
        "LINKEDIN": {
          "PLACEHOLDER": "Inserisci il nome utente LinkedIn",
          "LABEL": "LinkedIn"
        },
        "GITHUB": {
          "PLACEHOLDER": "Inserisci il nome utente GitHub",
          "LABEL": "Github"
        }
      },
      "UNSAVED_CHANGES": {
        "TITLE": "Modifiche non salvate",
        "DESCRIPTION": "Hai modifiche non salvate. Vuoi salvarle prima di chiudere?",
        "CONFIRM": "Salva",
        "CANCEL": "Scarta"
      }
    },
    "DELETE_AVATAR": {
      "API": {
        "SUCCESS_MESSAGE": "Avatar del contatto eliminato correttamente",
        "ERROR_MESSAGE": "Impossibile eliminare l'avatar del contatto. Riprova più tardi."
      }
    },
    "SUCCESS_MESSAGE": "Contatto salvato con successo",
    "ERROR_MESSAGE": "Si è verificato un errore, riprova"
  },
  "NEW_CONVERSATION": {
    "BUTTON_LABEL": "Avvia conversazione",
    "TITLE": "Nuova conversazione",
    "DESC": "Avvia una nuova conversazione inviando un nuovo messaggio.",
    "NO_INBOX": "Impossibile trovare una casella per inizializzare una nuova conversazione con questo contatto.",
    "FORM": {
      "TO": {
        "LABEL": "A"
      },
      "INBOX": {
        "LABEL": "Casella",
        "PLACEHOLDER": "Choose source inbox",
        "ERROR": "Seleziona una casella"
      },
      "SUBJECT": {
        "LABEL": "Oggetto",
        "PLACEHOLDER": "Oggetto",
        "ERROR": "L'oggetto non può essere vuoto"
      },
      "MESSAGE": {
        "LABEL": "Messaggio",
        "PLACEHOLDER": "Scrivi qui il tuo messaggio",
        "ERROR": "Il messaggio non può essere vuoto"
      },
      "ATTACHMENTS": {
        "SELECT": "Choose files",
        "HELP_TEXT": "Drag and drop files here or choose files to attach"
      },
      "SUBMIT": "Invia messaggio",
      "CANCEL": "Annulla",
      "SUCCESS_MESSAGE": "Messaggio inviato!",
      "GO_TO_CONVERSATION": "Visualizza",
      "ERROR_MESSAGE": "Impossibile inviare! Riprova"
    }
  },
  "CONTACTS_PAGE": {
    "LIST": {
      "TABLE_HEADER": {
        "SOCIAL_PROFILES": "Profili social"
      }
    }
  },
  "CUSTOM_ATTRIBUTES": {
    "BUTTON": "Aggiungi attributo personalizzato",
    "COPY_SUCCESSFUL": "Copiato negli appunti con successo",
    "SHOW_MORE": "Show all attributes",
    "SHOW_LESS": "Show less attributes",
    "ACTIONS": {
      "COPY": "Copia attributo",
      "DELETE": "Elimina attributo",
      "EDIT": "Modifica attributo"
    },
    "ADD": {
      "TITLE": "Crea attributo personalizzato",
      "DESC": "Aggiungi informazioni personalizzate a questo contatto."
    },
    "FORM": {
      "CREATE": "Aggiungi attributo",
      "CANCEL": "Annulla",
      "NAME": {
        "LABEL": "Nome attributo personalizzato",
        "PLACEHOLDER": "Es: id shopify",
        "ERROR": "Nome dell'attributo personalizzato non valido"
      },
      "VALUE": {
        "LABEL": "Valore attributo",
        "PLACEHOLDER": "Es: 11901 "
      },
      "ADD": {
        "TITLE": "Crea nuovo attributo ",
        "SUCCESS": "Attributo aggiunto con successo",
        "ERROR": "Impossibile aggiungere l'attributo. Riprova più tardi"
      },
      "UPDATE": {
        "SUCCESS": "Attributo aggiornato con successo",
        "ERROR": "Impossibile aggiornare l'attributo. Riprova più tardi"
      },
      "DELETE": {
        "SUCCESS": "Attributo eliminato con successo",
        "ERROR": "Impossibile eliminare l'attributo. Riprova più tardi"
      },
      "ATTRIBUTE_SELECT": {
        "TITLE": "Aggiungi attributi",
        "PLACEHOLDER": "Cerca attributi",
        "NO_RESULT": "Nessun attributo trovato"
      },
      "ATTRIBUTE_TYPE": {
        "LIST": {
          "PLACEHOLDER": "Seleziona valore",
          "SEARCH_INPUT_PLACEHOLDER": "Cerca valore",
          "NO_RESULT": "Nessun risultato trovato"
        }
      }
    },
    "VALIDATIONS": {
      "REQUIRED": "Valore valido richiesto",
      "INVALID_URL": "URL non valido",
      "INVALID_INPUT": "Invalid Input"
    }
  },
  "MERGE_CONTACTS": {
    "TITLE": "Unisci contatti",
    "DESCRIPTION": "Unisci i contatti per combinare due profili in uno, inclusi tutti gli attributi e le conversazioni. In caso di conflitto, gli attributi del contatto primario avranno la precedenza.",
    "PRIMARY": {
      "TITLE": "Contatto primario",
      "HELP_LABEL": "Da eliminare"
    },
    "PARENT": {
      "TITLE": "Contatto da unire",
      "PLACEHOLDER": "Cerca un contatto",
      "HELP_LABEL": "Da mantenere"
    },
    "SUMMARY": {
      "TITLE": "Riepilogo",
      "DELETE_WARNING": "Il contatto di <strong>{primaryContactName}</strong> verrà eliminato.",
      "ATTRIBUTE_WARNING": "I dettagli del contatto di <strong>{primaryContactName}</strong> verranno copiati in <strong>{parentContactName}</strong>."
    },
    "SEARCH": {
      "ERROR_MESSAGE": "Something went wrong. Please try again later."
    },
    "FORM": {
      "SUBMIT": " Unisci contatti",
      "CANCEL": "Annulla",
      "CHILD_CONTACT": {
        "ERROR": "Seleziona un contatto figlio da unire"
      },
      "SUCCESS_MESSAGE": "Contatto unito con successo",
      "ERROR_MESSAGE": "Impossibile unire i contatti, riprova!"
    },
    "DROPDOWN_ITEM": {
      "ID": "(ID: {identifier})"
    }
  },
  "CONTACTS_LAYOUT": {
    "HEADER": {
      "TITLE": "Contatti",
      "SEARCH_TITLE": "Search contacts",
      "SEARCH_PLACEHOLDER": "Search...",
      "MESSAGE_BUTTON": "Messaggio",
      "SEND_MESSAGE": "Invia messaggio",
      "SHOW_DETAILS": "Dettagli contatto",
      "BLOCKING": "Bloccaggio",
      "BLOCK_CONTACT": "Block contact",
      "UNBLOCK_CONTACT": "Unblock contact",
      "BLOCK_CONTACT_MESSAGE": "Bloccare questo contatto gli impedirà di creare nuove conversazioni e tutte le sue conversazioni esistenti saranno risolte. Sei sicuro di voler bloccare questo contatto?",
      "UNBLOCK_CONTACT_MESSAGE": "Sbloccare questo contatto gli permetterà di creare nuove conversazioni. Sei sicuro di voler sbloccare questo contatto?",
      "BLOCK_CONTACT_DISABLED": "Non utilizzabile. L'intero dominio del contatto è bloccato.",
      "BLOCK_CONTACT_DOMAIN": "Blocca dominio del contatto",
      "UNBLOCK_CONTACT_DOMAIN": "Sblocca dominio del contatto",
      "BLOCK_CONTACT_DOMAIN_DISABLED": "Questo dominio del contatto non può essere bloccato.",
      "BLOCK_CONTACT_DOMAIN_MESSAGE": "Bloccare il dominio bloccherà tutti i contatti esistenti e futuri per quel dominio.",
      "UNBLOCK_CONTACT_DOMAIN_MESSAGE": "Sbloccare il dominio rimuoverà il blocco da tutti i contatti per quel dominio (inclusi quelli bloccati manualmente).",
      "BLOCK_PUBLIC_DOMAIN_TITLE": "Dominio email pubblico",
      "BLOCK_PUBLIC_DOMAIN_MESSAGE": "{domain} è un dominio email pubblico utilizzato da molti mittenti non correlati tra loro, quindi non può essere bloccato nella sua interezza. Vuoi bloccare solo questo contatto ({email})?",
      "BLOCK_ONLY_THIS_CONTACT": "Blocca solo questo contatto",
      "DIAL": "Componi",
      "BREADCRUMB": {
        "CONTACTS": "Contatti"
      },
      "ACTIONS": {
        "CONTACT_CREATION": {
          "ADD_CONTACT": "Add contact",
          "EXPORT_CONTACT": "Export contacts",
          "IMPORT_CONTACT": "Import contacts",
          "SAVE_CONTACT": "Save contact",
          "EMAIL_ADDRESS_DUPLICATE": "Questo indirizzo email è in uso per un altro contatto.",
          "PHONE_NUMBER_DUPLICATE": "Questo numero di telefono è in uso per un altro contatto.",
          "SUCCESS_MESSAGE": "Contatto salvato con successo",
          "ERROR_MESSAGE": "Unable to save contact. Please try again later."
        },
        "BLOCK_SUCCESS_MESSAGE": "Questo contatto è stato bloccato con successo. Le sue conversazioni verranno risolte a breve in background.",
        "BLOCK_ERROR_MESSAGE": "Unable to block contact. Please try again later.",
        "UNBLOCK_SUCCESS_MESSAGE": "This contact is unblocked successfully",
        "UNBLOCK_ERROR_MESSAGE": "Unable to unblock contact. Please try again later.",
        "IMPORT_CONTACT": {
          "TITLE": "Import contacts",
          "DESCRIPTION": "Importa contatti attraverso un file CSV.",
          "DOWNLOAD_LABEL": "Scarica un csv di esempio.",
          "LABEL": "File CSV:",
          "CHOOSE_FILE": "Choose file",
          "CHANGE": "Cambia",
          "CANCEL": "annulla",
          "IMPORT": "Importa",
          "SUCCESS_MESSAGE": "You will be notified via email when the import is complete.",
          "ERROR_MESSAGE": "Si è verificato un errore, riprova"
        },
        "EXPORT_CONTACT": {
          "TITLE": "Export contacts",
          "DESCRIPTION": "Quickly export a csv file with comprehensive details of your contacts",
          "CONFIRM": "Export",
          "SUCCESS_MESSAGE": "Export is in progress, You will be notified via email when export file is ready to dowanlod.",
          "ERROR_MESSAGE": "Si è verificato un errore, riprova"
        },
        "SORT_BY": {
          "LABEL": "Ordina per",
          "OPTIONS": {
            "NAME": "Nome",
            "EMAIL": "Email",
            "PHONE_NUMBER": "Numero di telefono",
            "COMPANY": "Azienda",
            "COUNTRY": "Paese",
            "CITY": "Città",
            "LAST_ACTIVITY": "Last activity",
            "CREATED_AT": "Creato il"
          }
        },
        "ORDER": {
          "LABEL": "Ordering",
          "OPTIONS": {
            "ASCENDING": "Ascending",
            "DESCENDING": "Descending"
          }
        },
        "FILTERS": {
          "CREATE_SEGMENT": {
            "TITLE": "Vuoi salvare questo filtro?",
            "CONFIRM": "Salva filtro",
            "LABEL": "Nome",
            "PLACEHOLDER": "Enter the name of the filter",
            "ERROR": "Enter a valid name",
            "SUCCESS_MESSAGE": "Filter saved successfully",
            "ERROR_MESSAGE": "Unable to save filter. Please try again later."
          },
          "DELETE_SEGMENT": {
            "TITLE": "Conferma eliminazione",
            "DESCRIPTION": "Are you sure you want to delete this filter?",
            "CONFIRM": "Sì, elimina",
            "CANCEL": "No, Cancel",
            "SUCCESS_MESSAGE": "Filter deleted successfully",
            "ERROR_MESSAGE": "Unable to delete filter. Please try again later."
          }
        }
      }
    },
    "PAGINATION_FOOTER": {
      "SHOWING": "Showing {startItem} - {endItem} of {totalItems} contacts"
    },
    "FILTER": {
      "NAME": "Nome",
      "EMAIL": "Email",
      "PHONE_NUMBER": "Numero di telefono",
      "IDENTIFIER": "Identificatore",
      "COUNTRY": "Paese",
      "CITY": "Città",
      "CREATED_AT": "Creato il",
      "LAST_ACTIVITY": "Last activity",
      "REFERER_LINK": "Link referente",
      "BLOCKED": "Blocked",
      "BLOCKED_TRUE": "Vero",
      "BLOCKED_FALSE": "Falso",
      "BUTTONS": {
        "CLEAR_FILTERS": "Clear filters",
        "UPDATE_SEGMENT": "Update segment",
        "APPLY_FILTERS": "Applica filtri",
        "ADD_FILTER": "Add filter"
      },
      "TITLE": "Filtra contatti",
      "EDIT_SEGMENT": "Edit segment",
      "SEGMENT": {
        "LABEL": "Segment name",
        "INPUT_PLACEHOLDER": "Enter the name of the segment"
      },
      "ACTIVE_FILTERS": {
        "MORE_FILTERS": "+ {count} more filters",
        "CLEAR_FILTERS": "Clear filters"
      }
    },
    "CARD": {
      "OF": "of",
      "VIEW_DETAILS": "Visualizza dettagli",
      "EDIT_DETAILS_FORM": {
        "TITLE": "Modifica dettagli contatto",
        "FORM": {
          "FIRST_NAME": {
            "PLACEHOLDER": "Enter the first name",
            "ERROR": "Il nome è obbligatorio."
          },
          "LAST_NAME": {
            "PLACEHOLDER": "Enter the last name"
          },
          "EMAIL_ADDRESS": {
            "PLACEHOLDER": "Enter the email address",
            "DUPLICATE": "Questo indirizzo email è in uso per un altro contatto.",
            "ERROR": "Inserisci un indirizzo email valido."
          },
          "PHONE_NUMBER": {
            "PLACEHOLDER": "Enter the phone number",
            "DUPLICATE": "Questo numero di telefono è in uso per un altro contatto."
          },
          "CITY": {
            "PLACEHOLDER": "Enter the city name"
          },
          "COUNTRY": {
            "PLACEHOLDER": "Select country"
          },
          "BIO": {
            "PLACEHOLDER": "Enter the bio"
          },
          "COMPANY_NAME": {
            "PLACEHOLDER": "Inserisci il nome dell'azienda"
          }
        },
        "UPDATE_BUTTON": "Update contact",
        "SUCCESS_MESSAGE": "Contact updated successfully",
        "ERROR_MESSAGE": "Unable to update contact. Please try again later."
      },
      "SOCIAL_MEDIA": {
        "TITLE": "Edit social links",
        "FORM": {
          "FACEBOOK": {
            "PLACEHOLDER": "Add Facebook"
          },
          "GITHUB": {
            "PLACEHOLDER": "Add Github"
          },
          "INSTAGRAM": {
            "PLACEHOLDER": "Add Instagram"
          },
          "WHATSAPP": {
            "PLACEHOLDER": "Aggiungi WhatsApp"
          },
          "LINKEDIN": {
            "PLACEHOLDER": "Add LinkedIn"
          },
          "TWITTER": {
            "PLACEHOLDER": "Add Twitter"
          }
        }
      }
    },
    "DETAILS": {
      "CREATED_AT": "Created {date}",
      "LAST_ACTIVITY": "Last active {date}",
      "DELETE_CONTACT_DESCRIPTION": "Permanently delete this contact. This action is irreversible",
      "DELETE_CONTACT": "Elimina contatto",
      "DELETE_DIALOG": {
        "TITLE": "Conferma eliminazione",
        "DESCRIPTION": "Are you sure you want to delete this {contactName} contact?",
        "CONFIRM": "Sì, elimina",
        "API": {
          "SUCCESS_MESSAGE": "Contatto eliminato con successo",
          "ERROR_MESSAGE": "Impossibile eliminare il contatto. Riprova più tardi."
        }
      },
      "AVATAR": {
        "UPLOAD": {
          "ERROR_MESSAGE": "Could not upload avatar. Please try again later.",
          "SUCCESS_MESSAGE": "Avatar uploaded successfully"
        },
        "DELETE": {
          "SUCCESS_MESSAGE": "Avatar eliminato con successo",
          "ERROR_MESSAGE": "Could not delete avatar. Please try again later."
        }
      }
    },
    "SIDEBAR": {
      "TABS": {
        "ATTRIBUTES": "Attributi",
        "HISTORY": "History",
        "NOTES": "Note",
        "MERGE": "Merge",
        "ORDER_HISTORY": "Ordini recenti",
        "RETINO": "Retino"
      },
      "HISTORY": {
        "EMPTY_STATE": "Non ci sono precedenti conversazioni associate a questo contatto"
      },
      "ATTRIBUTES": {
        "SEARCH_PLACEHOLDER": "Search for attributes",
        "UNUSED_ATTRIBUTES": "{count} Used attribute | {count} Unused attributes",
        "EMPTY_STATE": "There are no contact custom attributes available in this account. You can create a custom attribute in settings.",
        "YES": "Sì",
        "NO": "No",
        "TRIGGER": {
          "SELECT": "Seleziona valore",
          "INPUT": "Enter value"
        },
        "VALIDATIONS": {
          "INVALID_NUMBER": "Invalid number",
          "REQUIRED": "Valore valido richiesto",
          "INVALID_INPUT": "Invalid input",
          "INVALID_URL": "URL non valido",
          "INVALID_DATE": "Invalid date"
        },
        "NO_ATTRIBUTES": "Nessun attributo trovato",
        "API": {
          "SUCCESS_MESSAGE": "Attributo aggiornato con successo",
          "DELETE_SUCCESS_MESSAGE": "Attributo eliminato con successo",
          "UPDATE_ERROR": "Impossibile aggiornare l'attributo. Riprova più tardi",
          "DELETE_ERROR": "Impossibile eliminare l'attributo. Riprova più tardi"
        }
      },
      "MERGE": {
        "TITLE": "Unisci contatto",
        "DESCRIPTION": "Combine two profiles into one, including all attributes and conversations. In case of conflict, the primary contact’s attributes will take precedence.",
        "PRIMARY": "Contatto primario",
        "PRIMARY_HELP_LABEL": "To be saved",
        "PRIMARY_REQUIRED_ERROR": "Please select a contact to merge with before proceeding",
        "PARENT": "To be merged",
        "PARENT_HELP_LABEL": "Da eliminare",
        "EMPTY_STATE": "No contacts found",
        "PLACEHOLDER": "Search for primary contact",
        "SEARCH_PLACEHOLDER": "Cerca un contatto",
        "SEARCH_ERROR_MESSAGE": "Could not search for contacts. Please try again later.",
        "SUCCESS_MESSAGE": "Contatto unito con successo",
        "ERROR_MESSAGE": "Impossibile unire i contatti, riprova!",
        "IS_SEARCHING": "Searching...",
        "BUTTONS": {
          "CANCEL": "annulla",
          "CONFIRM": "Unisci contatto"
        }
      },
      "NOTES": {
        "PLACEHOLDER": "Aggiungi una nota",
        "WROTE": "wrote",
        "YOU": "You",
        "SAVE": "Save note",
        "EMPTY_STATE": "There are no notes associated to this contact. You can add a note by typing in the box above."
      }
    },
    "EMPTY_STATE": {
      "TITLE": "No contacts found in this account",
      "SUBTITLE": "Start adding new contacts by clicking on the button below",
      "BUTTON_LABEL": "Add contact",
      "SEARCH_EMPTY_STATE_TITLE": "Nessun contatto corrisponde alla tua ricerca 🔍",
      "LIST_EMPTY_STATE_TITLE": "No contacts available in this view 📋"
    }
  },
  "COMPOSE_NEW_CONVERSATION": {
    "TITLE": "Nuova conversazione",
    "CONTACT_SEARCH": {
      "ERROR_MESSAGE": "We couldn’t complete the search. Please try again."
    },
    "FORM": {
      "GO_TO_CONVERSATION": "Visualizza",
      "SUCCESS_MESSAGE": "The message was sent successfully!",
      "ERROR_MESSAGE": "An error occurred while creating the conversation. Please try again later.",
      "NO_INBOX_ALERT": "There are no available inboxes to start a conversation with this contact.",
      "CONTACT_SELECTOR": {
        "LABEL": "A:",
        "TAG_INPUT_PLACEHOLDER": "Search for a contact with name, email or phone number",
        "CONTACT_CREATING": "Creating contact..."
      },
      "INBOX_SELECTOR": {
        "LABEL": "Via:",
        "BUTTON": "Show inboxes"
      },
      "EMAIL_OPTIONS": {
        "SUBJECT_LABEL": "Oggetto :",
        "SUBJECT_PLACEHOLDER": "Enter your email subject here",
        "CC_LABEL": "Cc:",
        "CC_PLACEHOLDER": "Search for a contact with their email address",
        "BCC_LABEL": "CCN:",
        "BCC_PLACEHOLDER": "Search for a contact with their email address",
        "BCC_BUTTON": "CCN"
      },
      "MESSAGE_EDITOR": {
        "PLACEHOLDER": "Scrivi qui il tuo messaggio..."
      },
      "WHATSAPP_OPTIONS": {
        "LABEL": "Select template",
        "SEARCH_PLACEHOLDER": "Search templates",
        "EMPTY_STATE": "No templates found",
        "TEMPLATE_PARSER": {
          "TEMPLATE_NAME": "WhatsApp template: {templateName}",
          "VARIABLES": "Variabili",
          "BACK": "Torna indietro",
          "SEND_MESSAGE": "Invia messaggio"
        }
      },
      "ACTION_BUTTONS": {
        "SEND": "Send ({keyCode})",
        "MARK_RESOLVED": "Segna la nuova conversazione come risolta dopo l'invio",
        "SAVE_DRAFT": "Salva bozza",
        "CREATE_AS_INTERNAL": "Crea come conversazione con nota",
        "SEND_AND_RESOLVE_ORIGINAL": "Invia e risolvi la conversazione originale ({keyCode})"
      },
      "DISCARD": "Scarta bozza",
      "DISCARD_MODAL": {
        "TITLE": "Scarta bozza",
        "DESCRIPTION": "Sei sicuro di voler scartare questa bozza?",
        "CONFIRM": "Sì, scarta",
        "CANCEL": "No, mantieni"
      }
    }
  }
}
